import Vue from 'vue'

const socket = {
  authenticate (token) {
    const d = {
      command: 'authorise',
      payload: {
        authToken: token
      }
    }
    Vue.prototype.$socket.sendObj(d)
  },
  subscribeStyleCreated () {
    const d = {
      command: 'subscribe',
      payload: {
        roomName: this.roomForStyleCreated()
      }
    }
    Vue.prototype.$socket.sendObj(d)
  },
  unsubscribeStyleCreated () {
    const d = {
      command: 'unsubscribe',
      payload: {
        roomName: this.roomForStyleCreated()
      }
    }
    Vue.prototype.$socket.sendObj(d)
  },
  roomForStyleCreated () {
    return 'style-fragment-created'
  },
  subscribeIncomingOctTerminal () {
    const d = {
      command: 'subscribe',
      payload: {
        roomName: this.roomForIncomigOctTerminal()
      }
    }
    Vue.prototype.$socket.sendObj(d)
  },
  unsubscribeIncomingOctTerminal () {
    const d = {
      command: 'unsubscribe',
      payload: {
        roomName: this.roomForIncomigOctTerminal()
      }
    }
    Vue.prototype.$socket.sendObj(d)
  },
  roomForIncomigOctTerminal () {
    return 'incoming-oct-terminal'
  }
}

export default socket
